import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '@/styles/journal.css';

const API = process.env.REACT_APP_BACKEND_URL;

/** Related journal articles for a case study page (themed by the page accent). */
export default function RelatedJournal({ caseStudy }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let live = true;
    fetch(`${API}/api/blog/posts?case_study=${encodeURIComponent(caseStudy)}&limit=3`)
      .then((r) => r.json())
      .then((d) => live && setPosts(Array.isArray(d) ? d : []))
      .catch(() => {});
    return () => { live = false; };
  }, [caseStudy]);

  if (posts.length === 0) return null;

  return (
    <section className="cs-journal" data-testid="case-study-journal">
      <p className="cs-journal-title">Read the full story on the Journal</p>
      <div className="cs-journal-list">
        {posts.map((p) => (
          <Link key={p.slug} to={`/journal/${p.slug}`} className="cs-journal-card" data-testid={`cs-journal-${p.slug}`}>
            <h4>{p.title}</h4>
            <p>{p.excerpt}</p>
            <span>{p.reading_minutes} min read →</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
